import c from 'color';

export const brandColors = {
  apache: {
    displayName: 'Apache',
    hex: '#dba65f',
  },
  lapel: {
    displayName: 'Lapel',
    hex: '#333333',
  },
  paloma: {
    displayName: 'Paloma',
    hex: '#ff8669',
  },
  gatsby: {
    displayName: 'Gatsby',
    hex: '#005ac8',
  },
  dove: {
    displayName: 'Dove',
    hex: '#f5f5f5',
  },
  pannaCotta: {
    displayName: 'Panna Cotta',
    hex: '#fff7ec',
  },
  selago: {
    displayName: 'Selago',
    hex: '#efe2ef',
  },
  emporer: {
    displayName: 'Emporer',
    hex: '#555555',
  },
  boulder: {
    displayName: 'Boulder',
    hex: '#777777',
  },
  dustyGray: {
    displayName: 'Dusty Gray',
    hex: '#999999',
  },
  silto: {
    displayName: 'Silto',
    hex: '#cccccc',
  },
  silver: {
    displayName: 'Silver',
    hex: '#bbbbbb',
  },
  alto: {
    displayName: 'Alto',
    hex: '#dddddd',
  },
  gallery: {
    displayName: 'Gallery',
    hex: '#eeeeee',
  },
  gold: {
    displayName: 'Gold',
    hex: '#a38546',
  },
};

const extraColors = {
  holidayRed: {
    displayName: 'Holiday Red',
    hex: '#b43006',
  },
  white: {
    displayName: 'White',
    hex: '#ffffff',
  },
  facebook: {
    displayName: 'Facebook',
    hex: '#3b5998',
  },
  google: {
    displayName: 'Google',
    hex: '#dc4e41',
  },
};

const alertColors = {
  error: {
    displayName: 'Error',
    hex: '#f0435d',
  },
  errorBackground: {
    displayName: 'Error Background',
    hex: '#fde3e7',
  },
  success: {
    displayName: 'Success',
    hex: '#00ad2e',
  },
  successBackground: {
    displayName: 'Success Background',
    hex: '#e2f5e3',
  },
  warning: {
    displayName: 'Warning',
    hex: '#fdf0d9',
  },
  waringBackground: {
    displayName: 'Warning Background',
    hex: '#f28400',
  },
};

const colors = (color, modifier, amount) => {
  const allColors = { ...brandColors, ...extraColors, ...alertColors };
  let colorData;
  if (typeof color === 'string') {
    colorData =
      color.indexOf('#') < 0
        ? allColors[color]
        : { displayName: 'custom', hex: color };
  }
  if (typeof colorData !== 'object') {
    colorData = allColors['lapel'];
  }

  if (modifier === 'lighten') {
    return c(colorData.hex)
      .mix(c('white'), amount || 0.2)
      .hex();
  } else if (modifier === 'darken') {
    return c(colorData.hex)
      .mix(c('black'), amount || 0.1)
      .hex();
  }

  return colorData.hex;
};

export default colors;

export function hover(color) {
  return color === 'white' ? colors(color, 'darken') : colors(color, 'lighten');
}
